import { z } from 'zod';

export const protocolOrderSchema = z.object({
  patientId: z.coerce.number().min(1, 'Please select a patient'),
});

export type ProtocolOrderFormValues = z.infer<typeof protocolOrderSchema>;
